"use client";

import Link from "next/link";
import { clsx } from "clsx";
import { usePathname } from "next/navigation";

const NavbarItem = ({ route, icon, text }: { route: string; icon: React.ReactNode, text: string }) => {
  const current = usePathname();
  const isActive = current == route;
  return (
    <span className="font-primary text-center">
      <Link
        className={clsx([
          isActive
            ? "transition-all text-neutral-900 dark:text-neutral-100 border-neutral-900 dark:border-neutral-100"
            : " text-neutral-500 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-200 transition-all",
            'block w-8 h-8',
            'flex flex-col items-center'
        ])}
        href={route}
      >
        <div className="w-5 h-5">
          {icon}
        </div>
        <div className="text-xxs md:text-sm">{text}</div>
      </Link>
    </span>
  );
};

export default NavbarItem;
